import Axios from "axios";
import React, { useEffect, useState } from "react";
import TeamDetails from "./TeamDetails";
import { useNavigate } from "react-router-dom";

const TeamCompiPage = ({ competition, setCompetition }) => {
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [onlineSubmission, setOnlineSubmission] = useState([]);
  const [csv, setCsv] = useState(
    ",Team ID,Name,MI Number,Phone,Email,College,City\n"
  );

  const getConfirmedTeams = () => {
    Axios.post(
      "https://ashish.moodi.org/competitions/get_conf_teams",
      {
        competition: competition.competitionId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        setTeams(res.data);
      })
      .catch((err) => console.error(err));
  };

  const getOnlineSubmission = () => {
    Axios.post(
      "https://ashish.moodi.org/competitions/get_onlin_submission",
      {
        competition: competition.competitionId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => setOnlineSubmission(res.data))
      .catch((err) => console.error(err));
  };

  const download_team_csv = () => {
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = `${competition.competitionName}.csv`;
    hiddenElement.click();
    setCsv(",Team ID,Name,MI Number,Phone,Email,College,City\n");
  };

  useEffect(() => {
    getConfirmedTeams();
    if (competition.isOnline) {
      setCsv(
        ",Team ID,Name,MI Number,Phone,Email,College,City,SubmissionLink,SubmittedOn\n"
      );
      getOnlineSubmission();
    }
    // eslint-disable-next-line
  }, [competition]);

  return (
    <div className="container-fluid">
      <div className="row">
        <h2 className="text-center col-sm-3">{competition.competitionName}</h2>
        <p className="col-sm-2 text-center">
          Total registrations: {teams.length}
        </p>
        {competition.isOnline ? (
          <p className="text-center col-sm-1">
            True: {onlineSubmission.length}
          </p>
        ) : (
          <></>
        )}
        <button
          className="btn btn-primary col-sm-2"
          onClick={download_team_csv}
        >
          Download CSV
        </button>
        <button
          className="btn btn-primary col-sm-2"
          onClick={() =>
            navigate(
              `/admin/competitions/slotting/${competition.competitionId}`
            )
          }
        >
          Do Slotting
        </button>
        <button
          className="btn btn-primary col-sm-2"
          onClick={() => navigate(`/admin/mul/compi_score/${competition.mcId}`)}
        >
          View Score Sheet
        </button>
      </div>
      <table className="container-fluid">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>MI Number</th>
            <th>Phone</th>
            <th>Email</th>
            {competition.isOnline ? (
              <>
                <th>In Semis</th>
                <th>In Finals</th>
              </>
            ) : (
              <></>
            )}
            <th>College</th>
            <th>City</th>
            {competition.isOnline ? (
              <>
                <th>Submission Link</th>
                <th>Submitted On</th>
              </>
            ) : (
              <></>
            )}
          </tr>
        </thead>
        <tbody>
          {teams.map((team) => {
            return (
              <TeamDetails
                competition={competition}
                team={team}
                csv={csv}
                setCsv={setCsv}
                onlineSubmission={onlineSubmission}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TeamCompiPage;
